/**
 * Created by slava on 11/9/18
 */

const OldPiggyBankWindow = CleverappsWindow.extend({
    onWindowLoaded: function (mission) {
        this.mission = mission;

        this.mission.logic.onShowBottomButtonPriceWithAnimation = this.createListener(this.showBottomButtonPriceWithAnimation.bind(this));
        this.mission.logic.onSetBalance = this.createListener(this.setBalance.bind(this));

        const leftTime = mission.getTimeLeft();
        const timer = this.createTimer(leftTime);

        const styles = cleverapps.styles.OldPiggyBankWindow;

        const animation = this.createAnimation(leftTime);

        const description = this.createDescription();

        const progress = this.progress = new OldPiggyBankProgressBar(mission);

        const padding = new cc.Node();
        padding.setContentSize(0, 30);

        const content = new cleverapps.Layout([animation, timer, description, progress, padding], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });

        this._super({
            name: "oldpiggybankwindow",
            title: Messages.get(mission.logic.isFull() ? "OldPiggyBankWindow.Title.Full" : "OldPiggyBankWindow.Title"),
            content,
            button: {
                width: styles.button.width,
                height: styles.button.height,
                onDisableHint: Messages.get("OldPiggyBankWindow.bottom_button_hint"),
                text: mission.logic.getCurrentPrice(),
                onPressed: function () {
                    mission.logic.buy((success) => {
                        if (success) {
                            this.close();
                        } else {
                            this.updateButton();
                        }
                    });
                }.bind(this)
            },
            help: function () {
                GuideWindow.createMissionRulesWindow(mission);
            },
            styles: cleverapps.styles.OldPiggyBankWindow,
            openSound: bundles.main.urls.shop_buy_effect
        });

        mission.logEvent(Mission.EVENTS.MISSION_WINDOW);

        cleverapps.paymentsLogic.onChangeStatus(this.updateButton.bind(this), this);
        this.mission.setNeedReview(false);

        this.updateButton();
        this.mission.logic.updateProgress();
    },

    createWindowButtons: function () {
        this.params.button.onClicked = this.params.button.onPressed || this.close.bind(this);
        this.bottomButton = new BottomButton(this.params.button);

        return this.bottomButton;
    },

    updateButton: function () {
        this.bottomButton.setString(this.mission.logic.getCurrentPrice());

        if (this.mission.logic.getProduct().isAvailable() && this.mission.logic.checkAvailableBottomButton()) {
            this.bottomButton.enable();
        } else {
            this.bottomButton.disable();
        }
    },

    showBottomButtonPriceWithAnimation: function () {
        if (!this.bottomButton.disabled || !this.mission.logic.getProduct().isAvailable()) {
            return;
        }

        const light = new cleverapps.Spine(bundles.piggy_bank.jsons.button_light);
        light.setAnchorPoint(0.5, 0.5);
        light.setAlignment({
            x: { align: "center" },
            y: { align: "center" }
        });

        light.setAnimation(0, "animation", false);
        this.bottomButton.addChild(light);
        light.setLocalZOrder(-1);

        this.bottomButton.runAction(new cc.Sequence(
            new cc.ScaleTo(0.5, 0.8),
            new cc.ScaleTo(0.3, 1),
            new cc.CallFunc(() => {
                this.bottomButton.enable();
            })
        ));
    },

    createAnimation: function () {
        const styles = cleverapps.styles.OldPiggyBankWindow;
        const pig = new cleverapps.Spine(bundles.old_piggy_bank_window.jsons.piggy_bank_json);
        pig.setAnchorPoint(0.5, 0.5);
        pig.setAnimation(0, this.mission.logic.isFull() ? "piggy_full" : "piggy_bank", true);
        if (this.mission.logic.isFull()) {
            this.runAction(new cc.RepeatForever(
                new cc.Sequence(
                    new cc.DelayTime(1.15),
                    cleverapps.effects.fireAction("piggybank.jump"),
                    new cc.DelayTime(1.38)
                )
            ));
        }

        const balance = this.balance = this.createBalance();

        pig.addChild(balance);

        balance.setAlignment(styles.balance.position);

        balance.setLocalZOrder(1);
        return pig;
    },

    setBalance: function () {
        this.balance.setScale(1);

        const delta = this.mission.result - this.mission.logic.getLastShowAmountProgress();
        const times = 1 + (delta / this.mission.logic.getMaxAmount()) * 50;

        const value = Math.floor((delta) / times);
        const duration = 0.6 / times;
        let currentBalance = this.mission.logic.getLastShowAmountProgress();

        this.balance.runAction(new cc.Sequence(
            new cc.ScaleTo(0.2, 1.2),
            new cc.DelayTime(0.2),
            cleverapps.effects.fireAction("piggybank.load"),
            new cc.Repeat(new cc.Sequence(
                new cc.DelayTime(duration),
                new cc.CallFunc(() => {
                    currentBalance += value;
                    this.balance.setString(this.mission.logic.getGoal(currentBalance));
                })
            ), times - 1),
            new cc.CallFunc(() => {
                this.balance.setString(this.mission.logic.getGoal(this.mission.result));
            }),
            new cc.DelayTime(0.3),
            new cc.ScaleTo(0.4, 1)
        ).setFinalize(() => {
            this.mission.logic.setLastShowAmountProgress(this.mission.result);
        }));
    },

    createBalance: function () {
        return new TextWithIcon(this.mission.logic.getGoal(this.mission.logic.getLastShowAmountProgress()), {
            font: cleverapps.styles.FONTS.OLD_PIGGY_BANK_BALANCE_FONT,
            iconSize: 1.2
        });
    },

    createTimer: function (leftTime) {
        const styles = cleverapps.styles.OldPiggyBankWindow.timer.text;
        const finishTimerText = cleverapps.UI.generateOnlyText(Messages.get("OldPiggyBankWindow.FinishTimerText"), cleverapps.styles.FONTS.WINDOW_TEXT);
        finishTimerText.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        finishTimerText.setDimensions(styles.width, styles.height);

        let timer;
        // eslint-disable-next-line prefer-const
        timer = new Timer(leftTime, (() => {
            finishTimerText.setVisible(true);
            if (timer) {
                timer.setVisible(false);
            }
            this.mission.wasDisplayedCompleted = true;
        }));

        if (leftTime > 0) {
            finishTimerText.setVisible(false);
        } else {
            timer.setVisible(false);
        }

        const wrapper = new cc.Node();
        wrapper.setContentSize2(timer.getContentSize());
        wrapper.setAnchorPoint(0.5, 0.5);
        timer.setAlignment(wrapper.width / 2, wrapper.height / 2);
        wrapper.addChild(timer);
        wrapper.addChild(finishTimerText);
        finishTimerText.setAlignment(wrapper.width / 2, wrapper.height / 2);

        return wrapper;
    },

    createDescription: function () {
        const styles = cleverapps.styles.OldPiggyBankWindow;

        const text = cleverapps.UI.generateOnlyText(Messages.get(this.mission.logic.getDescriptionText(), {
            value: this.mission.logic.getBaseAmount()
        }), cleverapps.styles.FONTS.WINDOW_TEXT);

        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setDimensions(styles.text.width, styles.text.height);
        return text;
    }
});

OldPiggyBankWindow.prototype.listBundles = function () {
    return ["old_piggy_bank_window"];
};

cleverapps.styles.FONTS.OLD_PIGGY_BANK_BALANCE_FONT = {
    size: 50,
    color: new cc.Color(0xFF, 0xE2, 0x40, 0xFF)
};

cleverapps.styles.OldPiggyBankWindow = {
    margin: 20,
    padding: {
        bottom: 50
    },
    amount: {
        width: 260,
        height: 64,

        margin: 10
    },

    text: {
        width: 640,
        height: 150
    },

    button: {
        width: 300,
        height: 100
    },

    pig: {
        position: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 0 }
        }
    },

    balance: {
        position: {
            x: { align: "center", dx: 0 },
            y: { align: "top", dy: -20 }
        }
    },

    timer: {
        text: {
            width: 640,
            height: 50
        }
    },

    goal: {
        iconSize: 11
    },

    deltaAnimation: {
        dy: -40
    }
};
